import React from 'react';
import { usePreferences } from '../state/usePreferences';

// The button only. It sits inside the last section's closing card, under
// that card's own copy.
const SubmitCard = ({
  onOpenSubmit
}) => {
  const {
    doc,
    locked,
    closed,
    readOnly
  } = usePreferences();
  if (readOnly) return null;

  // Closed by the deadline reads differently from submitted by the client.
  const label = doc.submitted ? 'Preferences submitted' : closed ? 'Form closed' : 'Submit creative preferences';
  return React.createElement("div", {
    className: "cp-submitrow"
  }, React.createElement("button", {
    type: "button",
    className: `cp-submit${locked ? ' is-done' : ''}`,
    disabled: locked,
    onClick: onOpenSubmit
  }, label));
};
export default SubmitCard;
